import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-b80f143a")
const _hoisted_1 = {
  ref: "observer",
  class: "contact-us"
}
const _hoisted_2 = { ref: "successRef" }
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-4" }, null, -1)
const _hoisted_5 = { class: "col-12 col-md-4" }
const _hoisted_6 = { class: "icon mb-4" }
const _hoisted_7 = { class: "title title--small m-0" }
const _hoisted_8 = { class: "fw-medium fs-16 fs-md-18 color-font mb-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-4" }, null, -1)
const _hoisted_10 = { class: "contact-us__section mt-5" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row d-none d-lg-flex" }
const _hoisted_13 = { class: "col-12 col-lg-6 pt-5 pb-5" }
const _hoisted_14 = { class: "col-12 col-lg-6" }
const _hoisted_15 = { class: "d-block d-lg-none" }
const _hoisted_16 = { class: "d-block d-lg-none" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thank_you = _resolveComponent("thank-you")!
  const _component_notus_svg_icon = _resolveComponent("notus-svg-icon")!
  const _component_notus_button = _resolveComponent("notus-button")!
  const _component_notus_benefits = _resolveComponent("notus-benefits")!
  const _component_notus_form = _resolveComponent("notus-form")!
  const _component_notus_benefits_slider = _resolveComponent("notus-benefits-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " ", 512),
    (_ctx.leadWasSend)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass([{
        'contact-us__section--success mt-5': _ctx.leadWasSend && _ctx.leadSentSuccess,
        'contact-us__section--error mt-5': _ctx.leadWasSend && !_ctx.leadSentSuccess,
      }, "container text-center"])
        }, [
          (_ctx.leadSentSuccess)
            ? (_openBlock(), _createBlock(_component_thank_you, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_notus_svg_icon, {
                      iconType: "error",
                      cover: false
                    })
                  ]),
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('page.contact.error.title')), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('page.contact.error.sub_title')), 1),
                  _createVNode(_component_notus_button, {
                    size: "large",
                    class: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTop()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('page.contact.error.cta')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_9
              ]))
        ], 2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_notus_benefits)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_notus_form, {
                    onLeadWasSent: _ctx.scrollToSuccess,
                    contactForm: _ctx.contactForm
                  }, null, 8, ["onLeadWasSent", "contactForm"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_notus_benefits_slider)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_notus_form, {
              onLeadWasSent: _ctx.scrollToSuccess,
              contactForm: _ctx.contactForm
            }, null, 8, ["onLeadWasSent", "contactForm"])
          ])
        ], 64))
  ], 512))
}